import React from "react";
var __jsx = React.createElement;
import { Tooltip } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
/** Field label with a required marker and an info tooltip listing the field's constraints. */
export function EncounterFieldLabel(_ref) {
  var label = _ref.label,
    required = _ref.required,
    validations = _ref.validations;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasValidations = Boolean(validations && validations.length > 0);
  return /*#__PURE__*/React.createElement("span", {
    className: "inline-flex items-center gap-1.5"
  }, /*#__PURE__*/React.createElement("span", null, label, required ? /*#__PURE__*/React.createElement("span", {
    className: "text-sds-urgent-default"
  }, " *") : null), hasValidations ? /*#__PURE__*/React.createElement(Tooltip, {
    multiline: true,
    withArrow: true,
    position: "top",
    label: /*#__PURE__*/React.createElement("span", {
      className: "flex flex-col gap-1"
    }, validations === null || validations === void 0 ? void 0 : validations.map(function (rule) {
      return /*#__PURE__*/React.createElement("span", {
        key: rule.message
      }, rule.message);
    }))
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex cursor-help items-center text-sds-base-tertiary",
    "aria-label": t("field_constraints", {
      defaultValue: "Field constraints"
    })
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircleInfo,
    className: "h-4 w-4"
  }))) : null);
}